import { useState, useMemo } from 'react'
import { Input } from 'uikit'
import styled from 'styled-components'
import debounce from 'lodash/debounce'
import { useTranslation } from 'contexts/Localization'
import DtPicker from "react-calendar-datetime-picker";

interface Props {
  title:string
  isRequired:boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  showBottom?:boolean
}

const DateInput: React.FC<Props> = ({title,isRequired, onChange: onChangeCallback, placeholder = '',showBottom =false }) => {

  const { t } = useTranslation()

  const debouncedOnChange = useMemo(
    () => debounce((e: React.ChangeEvent<HTMLInputElement>) => onChangeCallback(e), 500),
    [onChangeCallback],
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedOnChange(e)
  }

  return (
    <div style={{width:'100%'}}>
      <div style={{marginBottom:8,marginLeft:2}}>{title}{isRequired?'*':''}</div>
      <DtPicker headerClass={'datePicker'} onChange={onChange} placeholder={placeholder} withTime
                showTimeInput />
      {
        showBottom?<div/>:<div style={{marginBottom:20}}/>
      }
    </div>
  )
}

export default DateInput
